import { Injectable } from "@angular/core";
@Injectable()
export class DataSharing {
    data = [];

    public static store(key, val) {
        return localStorage.setItem(key, val);
    }

    public static retrieve(key) {
        return localStorage.getItem(key);
    }

    public static getInfo() {
        return DataSharing.retrieve('info');
    }

    public static getToken() {
        return DataSharing.retrieve('token');
    }

    public static getPageToken() {
        return DataSharing.retrieve('pageToken');
    }

    public static remove(key) {
        return localStorage.removeItem(key);
    }

    public static clearAll() {
        DataSharing.clearCookies();
        sessionStorage.clear();
        return localStorage.clear();
    }

    public static clearCookies() {
        const cookies = document.cookie.split(";");
      
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
    }

    public static StoreJsonObj(key, data) {
        return DataSharing.store(key, JSON.stringify(data));
    }

    public static GetJsonObj(key) {
        return JSON.parse(DataSharing.retrieve(key));
    }

    public static user_role() {
        const info = DataSharing.GetJsonObj('info');
        if (!info) {
            return null;
        }
        return info.role;
    }

    public static user_id() {
        const info = DataSharing.GetJsonObj('info');
        if (!info) {
            return null;
        }
        return info.user_id;
    }

    public static domain_id() {
        const settings = DataSharing.GetJsonObj('settings');
        if (!settings) {
            return null;
        }
        return settings.id;
    }

    public static user_permissions() {
        const info = DataSharing.GetJsonObj('info');
        if (!info) {
            return null;
        }
        return info.permissions;
    }

    public static level_info() {
        const info = DataSharing.GetJsonObj('level_info');
        if (!info) {
            return null;
        }
        return info;
    }
}
